// src/utils/getQueryParams.ts

export const getQueryParams = (): Record<string, string | null> => {
    const params = new URLSearchParams(window.location.search);
    return {
      utm_source: params.get("utm_source"),
      utm_medium: params.get("utm_medium"),
      utm_campaign: params.get("utm_campaign"),
      utm_content: params.get("utm_content"),
      utm_term: params.get("utm_term"),
      utm_custom1: params.get("utm_custom1"),
      utm_custom2: params.get("utm_custom2"),
      utm_custom3: params.get("utm_custom3"),
      utm_custom4: params.get("utm_custom4"),
      utm_custom5: params.get("utm_custom5"),
      utm_custom6: params.get("utm_custom6"),
      utm_custom7: params.get("utm_custom7"),
      utm_custom8: params.get("utm_custom8"),
      utm_custom9: params.get("utm_custom9"),
      utm_custom10: params.get("utm_custom10"),
 

      utm_session_referrer: document.referrer || "direct",
    };
  };
  